import * as React from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import emailMask from 'text-mask-addons/dist/emailMask'

import MaskInput from '../shared/MaskInput'

interface IEmailInputProps {
  email: string
  onChange: React.ChangeEventHandler
  onBlur: (e: any) => void
  error?: boolean
}

const EmailInput: React.SFC<IEmailInputProps> = ({
  email,
  onChange,
  onBlur,
  error
}) => (
  <FormControl fullWidth required error={error}>
    <InputLabel>Email</InputLabel>
    <Input
      name="email"
      fullWidth
      autoComplete="email"
      value={email}
      onChange={onChange}
      onBlur={onBlur}
      inputComponent={MaskInput}
      inputProps={{
        mask: emailMask
      }}
    />
  </FormControl>
)

export default EmailInput



// WEBPACK FOOTER //
// ./src/components/shared/EmailInput.tsx